import { MINIMUM_QUERY_LENGTH } from '@constants';
import LoadingIcon from '@svg/progress-activity.svg';
import SearchIcon from '@svg/search.svg';
import useDebounce from '@utils/useDebounce';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useInstantSearch, useSearchBox } from 'react-instantsearch';

import styles from './SearchInput.module.scss';

export default function SearchInput({ controls }) {
  const { query, refine } = useSearchBox();
  const { status } = useInstantSearch();
  const [inputValue, setInputValue] = useState(query);
  const loading = status === 'loading';

  const refineDebounced = useDebounce(newQuery => refine(newQuery), 350);

  function setQuery(newQuery) {
    setInputValue(newQuery);
    // Sets a new query and searches.
    refineDebounced(newQuery);
  }

  useEffect(() => {
    // Update the component when query changes from outside.
    if (inputValue !== query) {
      setInputValue(query);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <>
      <div className={styles.inputContainer}>
        <SearchIcon className={styles.icon} />

        <input
          type="text"
          role="combobox"
          aria-controls={controls}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
          aria-expanded={false}
          aria-haspopup
          aria-label="Zoeken in Vitalis"
          className={styles.input}
          placeholder="Zoeken in Vitalis"
          value={inputValue}
          onChange={event => {
            setQuery(event.currentTarget.value);
          }}
        />
        {loading && <LoadingIcon className={styles.loadingIcon} />}
      </div>
      {(!inputValue?.length || inputValue?.length < MINIMUM_QUERY_LENGTH) && (
        <span className={styles.hint}>
          Min. {MINIMUM_QUERY_LENGTH} karakters
        </span>
      )}
    </>
  );
}

SearchInput.propTypes = {
  controls: PropTypes.string.isRequired,
};
